import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import CustomCard from "../../../../modules/atoms/cards/main";
import Icon from "../../../../icons/main";
import { ReportCardType } from "./report.types";
import { useEffect } from "react";
import SuperSetPage from "../super_set/main";
const ReportCard = ({
  title,
  discription,
  imageUrl,
  onClick,
  id,
  expanded,
}: // showMore,
ReportCardType) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const isMediumScreen = useMediaQuery("(max-width:900px)");
  console.log(imageUrl);
  return (
    <CustomCard
      style={{
        padding: "1rem",
        height: expanded ? "auto" : "12.875rem",
        borderRadius: "1.146rem",
        backgroundColor: "#F7F9FB",
      }}
    >
      <Grid container rowSpacing={2}>
        <Grid item xs={12} container>
          <Grid
            item
            xs={expanded ? 2 : 11}
            md={expanded ? 1.5 : 11}
            lg={expanded ? 1 : 11}
          >
            <CustomCard
              style={{
                width: isSmallScreen
                  ? "3rem"
                  : isMediumScreen
                  ? "3.25rem"
                  : "4.25rem",
                height: isSmallScreen
                  ? "3rem"
                  : isMediumScreen
                  ? "3.25rem"
                  : "4.25rem",
                borderRadius: "0.625rem",
                backgroundColor: "grey",
              }}
            ></CustomCard>
          </Grid>

          {expanded && (
            <Grid item xs={9.8} md={10.3} lg={10.8} container>
              <Grid item xs={12}>
                <Typography variant="reportCardTitle">
                  {title.length <= 30 ? title : title.slice(0, 30) + "..."}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {discription.length < 210
                    ? discription
                    : discription.slice(0, 207) + "..."}
                </Typography>
              </Grid>
            </Grid>
          )}
          <Grid
            item
            xs={expanded ? 0.2 : 1}
            lg={expanded ? 0.2 : 1}
            container
            justifyContent="flex-end"
          >
            {!expanded
              ? Icon["ExpandNavigate"]({
                  width: { xs: "1.015rem", md: "1.125rem", lg: "1.125rem" },
                  height: { xs: "1.015rem", md: "1.125rem", lg: "1.125rem" },
                  color: "grey",
                  id: id,
                  onClick,
                })
              : Icon["CollapseNavigate"]({
                  width: { xs: "1.015rem", md: "1.125rem", lg: "1.125rem" },
                  height: { xs: "1.015rem", md: "1.125rem", lg: "1.125rem" },
                  color: "grey",
                  onClick,
                })}
          </Grid>
        </Grid>

        {!expanded && (
          <Grid item xs={12} container rowGap={0.5} columnGap={1}>
            <Grid item xs={12}>
              <Typography variant="reportCardTitle">
                {title.length <= 30 ? title : title.slice(0, 30) + "..."}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="body1">
                {discription.length < 150
                  ? discription
                  : discription.slice(0, 150) + "..."}
              </Typography>
            </Grid>
          </Grid>
        )}

        {expanded && (
          <Grid item xs={12}>
            <SuperSetPage id={id} />
          </Grid>
        )}
      </Grid>
    </CustomCard>
  );
};
export default ReportCard;
